import { BaseIcon, BaseIconProps } from './BaseIcon';

export const DatabaseGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="databaseGrad" {...props}>
    <ellipse cx="12" cy="5" rx="9" ry="3" stroke="url(#databaseGrad)" />
    <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" stroke="url(#databaseGrad)" />
    <path d="M3 12c0 1.66 4 3 9 3s9-1.34 9-3" stroke="url(#databaseGrad)" />
  </BaseIcon>
);
